<div *ngIf="globalStats && globalStats.numberFormation > 0" class="border-end">
	<div class="row text-center mb-2">
		<span class="theme-main-color fw-bold fs-5">
			Taux de satisfaction des spécialités
		</span>
	</div>
	<div class="row" *ngIf="isSESSAD">
		<div *ngIf="lsfStats.numberFormation > 0" class="col-12 col-lg-3">
			<div echarts [options]="chartOptionSatisfactionLSF"></div>
		</div>
		<div
			*ngIf="lsfStats.numberFormation < 0 || lsfStats.numberFormation === 0"
			class="col-12 col-lg-3 d-flex align-items-center justify-content-center"
		>
			<span class="text-center">Pas de données pour LSF</span>
		</div>
		<div *ngIf="lpcStats.numberFormation > 0" class="col-12 col-lg-3">
			<div echarts [options]="chartOptionSatisfactionLPC"></div>
		</div>
		<div
			*ngIf="lpcStats.numberFormation < 0 || lpcStats.numberFormation === 0"
			class="col-12 col-lg-3 d-flex align-items-center justify-content-center"
		>
			<span class="text-center">Pas de données pour LPC</span>
		</div>
		<div *ngIf="pdnStats.numberFormation > 0" class="col-12 col-lg-3">
			<div echarts [options]="chartOptionSatisfactionPDN"></div>
		</div>
		<div
			*ngIf="pdnStats.numberFormation < 0 || pdnStats.numberFormation === 0"
			class="col-12 col-lg-3 d-flex align-items-center justify-content-center"
		>
			<span class="text-center">Pas de données pour Prise de notes</span>
		</div>
		<div *ngIf="oralStats.numberFormation > 0" class="col-12 col-lg-3">
			<div echarts [options]="chartOptionSatisfactionOral"></div>
		</div>
		<div
			*ngIf="oralStats.numberFormation < 0 || oralStats.numberFormation === 0"
			class="col-12 col-lg-3 d-flex align-items-center justify-content-center"
		>
			<span class="text-center">Pas de données pour Oral</span>
		</div>
	</div>
	<div class="row" *ngIf="isSAAD">
		<div *ngIf="globalStats.numberFormation > 0" class="col-12 col-lg-4">
			<div echarts [options]="chartOptionSatisfactionSAAD"></div>
		</div>
		<div
			*ngIf="
				globalStats.numberFormation < 0 || globalStats.numberFormation === 0
			"
			class="col-12 col-lg-3 d-flex align-items-center justify-content-center"
		>
			<span class="text-center">Pas de données</span>
		</div>
	</div>
</div>
<div
	*ngIf="
		!globalStats ||
		globalStats.numberFormation < 0 ||
		globalStats.numberFormation === 0
	"
>
	<div class="row text-center mb-2">
		<span class="theme-main-color fw-bold fs-5">
			Taux de satisfaction des spécialités
		</span>
	</div>
	<div class="row">
		<span>
			Désolé, il n'ya pas de statistiques de satisfaction pour cette semaine
		</span>
	</div>
</div>
